import {ProjectAutocompleteInput} from '../../projects/components/project-autocomplete-input';
import {StatusSelectInput} from './status-select-input';
import DataTableFilters, {
  DataTableFiltersProps,
} from '@/components/refinedev/data-table/data-table-filters';

type TaskFiltersProps = Pick<DataTableFiltersProps, 'table'>;

const TaskFilters: React.FC<TaskFiltersProps> = ({table}) => {  
  return (
    <DataTableFilters
      table={table}      
      defaultValues={{
        status: null,
        project: null,
      }}
      className="w-[500px]"
      transformFilter={data => {
        const filters: any[] = [];
        // Filter by project
        if (data.project && data.project.id) {
          filters.push({
            field: 'project_id',
            operator: 'eq',
            value: data.project.id,
          });
        }
        // Filter by status
        if (data.status) {
          filters.push({
            field: 'status',
            operator: 'eq',
            value: data.status,
          });
        }

        return filters;
      }}      
      showAs="collapsible"
      autoApply={true}
      closeWhenApply={false}
      // closeWhenApply={false}
      // asPopover={false}
    >
      <div className="flex space-x-1 items-center">
        <ProjectAutocompleteInput source="project" label="" EmptyValue />
        <StatusSelectInput source="status" label="" />
      </div>
    </DataTableFilters>
  );
};

export default TaskFilters;
